<template>
  <v-dialog :value="value" persistent width="500" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-5 pr-2 pt-4 pb-2">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          TPR Length Warning
        </div>
      </v-card-title>
      <v-container fluid class="pa-0">
        <div class="px-6 pb-4 d-flex justify-center">TPR promotion is less than 3 weeks in length. Please confirm before continuing.</div>
        <div class="d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close()">
            Cancel
          </v-btn>
          <v-btn class="mb-4" color="warning" @click="confirm()">
            Confirm
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ShortTPRAlertModal',
  props: [
    'value'
  ],
  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('submitWithShortTPRAlert')
    }
  }
}
</script>
<style>
.title {
  width: 73%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>